import {
  Alert,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";
import { SubstituteResult } from "../../../types";

interface MeetingSubstituteResultDisplayProps {
  results: SubstituteResult[];
}

const MeetingSubstituteResultDisplay: React.FC<MeetingSubstituteResultDisplayProps> = ({
  results,
}) => {
  return (
    <Stack width={"100%"}>
      {results.length == 0 && (
        <Alert severity="info">No results to display.</Alert>
      )}

      <List disablePadding>
        {results.map((result, index) => {
          return (
            <ListItem key={`${result.email}-${index}`}>
              <Alert
                severity={result.status == 200 ? "success" : "error"}
                sx={{
                  width: "100%",
                }}
              >
                <Typography variant="body1">
                  {result.email} - {result.status == 200 ? "Invited Successfully" : "Invitation Failed"}
                </Typography>
              </Alert>
            </ListItem>
          );
        })}
      </List>
    </Stack>
  );
};

export default MeetingSubstituteResultDisplay;
